import React from "react";

interface FadeUpTextProps {
  children: React.ReactNode;
  className?: string;
  delay?: string; // e.g. "delay-500"
}

const FadeUpText: React.FC<FadeUpTextProps> = ({ children, className = "", delay = "" }) => {
  return (
    <span className={`inline-block opacity-0 animate-fadeUp ${delay} ${className}`}>
      {children}
    </span>
  );
};

export default FadeUpText;
